import { forms } from '../data/forms';

// ASRS v1.1 DEHB (LİSE) HESAPLAMA MOTORU
export const calculateAsrs = (answers) => {
  const testDef = forms.find(t => t.id === 'asrs_form');
  let partA = { score: 0, critical: 0, threshold: 4 }; // İlk 6 soru (Tarama)
  let partB = { score: 0, critical: 0 }; // Son 12 soru (Detay)
  let risks = [];
  let focusAreas = new Set();
  let socialImpacts = new Set();

  Object.keys(answers).forEach(key => {
    const id = parseInt(key);
    const val = parseInt(answers[key]) || 0;
    const qText = testDef?.items?.find(q => q.id === id)?.text || `Madde ${id}`;

    let isCritical = false;
    // DSÖ'nün sihirli eşik kuralı: Bazı sorularda Bazen(2) yeterli, bazılarında Sıklıkla(3) gerekir.
    if ([1, 2, 3, 9, 12, 17].includes(id)) {
        if (val >= 2) isCritical = true; // Bazen, Sıklıkla, Çok Sık
    } else {
        if (val >= 3) isCritical = true; // Sıklıkla, Çok Sık
    }

    if (id >= 1 && id <= 6) {
        partA.score += val;
        if (isCritical) partA.critical += 1;
    } else if (id >= 7 && id <= 18) {
        partB.score += val;
        if (isCritical) partB.critical += 1;
    }

    if (isCritical) {
        risks.push({ id, text: qText, score: val, isCritical: true });
        
        // PDR İÇİN EKSTRA KART VERİLERİ (Görüşme Odakları ve İşlevsellik)
        if ([1,2,4,7,8].includes(id)) focusAreas.add("Zaman Yönetimi ve Erteleme Davranışı");
        if ([3,9,10,11].includes(id)) focusAreas.add("Dikkat Sürdürme ve Odaklanma");
        if ([5,6,12,13,14].includes(id)) focusAreas.add("Fiziksel Huzursuzluk / İçsel Sıkıntı");
        if ([15,16,17,18].includes(id)) focusAreas.add("Dürtüsellik ve Karşı Tarafı Dinleyememe");

        if ([1,4,7,8].includes(id)) socialImpacts.add("Akademik görevleri tamamlamada güçlük ve ders başarısında dalgalanma yaşayabilir.");
        if ([15,16,17,18].includes(id)) socialImpacts.add("Söz kesme ve dürtüsellik nedeniyle akran ilişkilerinde çatışma veya yanlış anlaşılma yaşayabilir.");
        if ([3,9,10].includes(id)) socialImpacts.add("Randevuları ve eşyaları unutma sebebiyle çevre tarafından 'sorumsuz' olarak etiketlenebilir.");
    }
  });

  const isRedAlarm = partA.critical >= partA.threshold; 
  const isYellowAlarm = partA.critical === 3 || (partA.critical > 0 && partB.critical >= 4);

  let summary = "DENGELİ (NORMAL SEVİYE)"; let colorCode = "green";
  if (isRedAlarm) { summary = "YÜKSEK RİSK (KIRMIZI ALARM)"; colorCode = "red"; }
  else if (isYellowAlarm) { summary = "KLİNİK SINIRDA (SARI ALARM)"; colorCode = "amber"; }

 // --- YENİ EKLENEN STANDART PAKETLEME (ZARF) ---
  const totalRawScore = partA.score + partB.score;
  const riskScore = Math.round((totalRawScore / 72) * 100); // UI sıralaması için 100'lük sisteme çevirdik (18 soru * 4 = 72 max puan)
  const masterRisk = isRedAlarm ? "high" : (isYellowAlarm ? "medium" : "low");

  return { 
    // Öğrenci Klasörleri (StudentFolders) burayı okuyacak:
    riskScore: riskScore,
    masterRisk: masterRisk,
    isCritical: false, // DEHB şüphesi önemli bir risktir ama anlık "Hayati/Kriz" durumu (intihar vb.) olmadığı için false bırakıyoruz.
    domain: "behavioral", 
    
    // Uygulamanın eski/mevcut işleyişi (BUNLARA HİÇ DOKUNMADIK):
    summary, 
    colorCode, 
    analysis: "ASRS analizi tamamlandı.", 
    risks, 
    scores: { 
      partA, 
      partB, 
      focus: Array.from(focusAreas), 
      impacts: Array.from(socialImpacts) 
    } 
  };
};